// Web Awesome styles
import '@awesome.me/webawesome/dist/styles/webawesome.css';

import htmx from "htmx.org/dist/htmx.esm";
// Import the components you want to use
import '@awesome.me/webawesome/dist/components/button/button.js';
import '@awesome.me/webawesome/dist/components/input/input.js';
import '@awesome.me/webawesome/dist/components/card/card.js';
import '@awesome.me/webawesome/dist/components/avatar/avatar.js';
import '@awesome.me/webawesome/dist/components/copy-button/copy-button.js';
import '@awesome.me/webawesome/dist/components/tooltip/tooltip.js';
import '@awesome.me/webawesome/dist/components/badge/badge.js';
import '@awesome.me/webawesome/dist/components/dialog/dialog.js';
import '@awesome.me/webawesome/dist/components/select/select.js';
import '@awesome.me/webawesome/dist/components/radio/radio.js';
import '@awesome.me/webawesome/dist/components/textarea/textarea.js';
import '@awesome.me/webawesome/dist/components/drawer/drawer.js';
import '@awesome.me/webawesome/dist/components/icon/icon.js';
import '@awesome.me/webawesome/dist/components/dropdown-item/dropdown-item.js';
import '@awesome.me/webawesome/dist/components/dropdown/dropdown.js';
import '@awesome.me/webawesome/dist/components/divider/divider.js';
import '@awesome.me/webawesome/dist/components/button-group/button-group.js';
import '@awesome.me/webawesome/dist/components/radio-group/radio-group.js';
import '@awesome.me/webawesome/dist/components/checkbox/checkbox.js';
import '@awesome.me/webawesome/dist/components/callout/callout.js';
import '@awesome.me/webawesome/dist/components/format-number/format-number.js';
import '@awesome.me/webawesome/dist/components/divider/divider.js';
import {registerIconLibrary} from '@awesome.me/webawesome/dist/webawesome.js';
import posthog from 'posthog-js'

// Project code
import {startSync} from "./form-state-tracking";
import onCardClick from "./clickable-card";
import CheckBoxRange from "./checkbox-range";
import * as CheckboxRange from "./checkbox-range";

const CONTEXT = JSON.parse(document.getElementById('pinot-browser-context').textContent)

registerIconLibrary('material', {
  resolver: name => {
    const match = name.match(/^(.*?)(_(round|sharp))?$/);
    return `https://cdn.jsdelivr.net/npm/@material-icons/svg@1.0.33/svg/${match[1]}/${match[3] || 'outline'}.svg`;
  },
  mutator: svg => svg.setAttribute('fill', 'currentColor'),
});

/**
 * This is a small hack: it listens to the `wa-show` events on the dialog elements, firing another custom event that
 * allows the content of the dialog to be loaded.
 * Without this hack, children elements of the dialog firing `wa-show` event (namely, the wa-select element) would
 * make the content of the dialog to be reloaded.
 */
window.addEventListener("wa-show", ({target}) => {
  if (target.nodeName === "WA-DIALOG") {
    target.dispatchEvent(new Event("wa-dialog-show"));
  }
})

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("form[data-state-tracking]").forEach((formElement) => {
    startSync(formElement);
  });
});

document.addEventListener("htmx:afterSwap", () => {
  document.querySelectorAll("form[data-state-tracking]").forEach((formElement) => {
    startSync(formElement);
  });
});

document.body.addEventListener("click", onCardClick);

function hasAnalyticsConsent() {
  return Boolean(window.CookieConsent?.acceptedCategory("analytics"));
}

function syncPosthogConsent() {
  if (hasAnalyticsConsent()) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
}

if (CONTEXT.POSTHOG_API_KEY) {
  posthog.init(CONTEXT.POSTHOG_API_KEY, {
    opt_out_capturing_by_default: true,
    api_host: "https://eu.i.posthog.com",
    defaults: "2026-05-30",
    tracing_headers: CONTEXT.HOSTNAME ? [CONTEXT.HOSTNAME] : [],
    loaded: (posthog) => {
        if (CONTEXT?.identity) {
            posthog.identify(CONTEXT.identity, {
                email: CONTEXT.email,
            })
        }
    },

  })
  syncPosthogConsent();
  window.addEventListener("cc:onConsent", syncPosthogConsent);
  window.addEventListener("cc:onChange", syncPosthogConsent);
}

CheckboxRange.setUp();
window.addEventListener("htmx:afterSwap", CheckboxRange.clear);

window.htmx = htmx;
